import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BadgeButton } from '../../../../components/BadgeButton/BadgeButton';
import { getOrderDescription } from '../../../../helpers/order';
import { useServiceDate } from '../../../../hooks/useServiceDate';
import { useLanguage } from '../../../../locale/useLanguage';
import { Order } from '../../../../models';
import { Routes } from '../../../../routes/types';

import './OrderElement.css';

type OrderElementProps = {
  order: Order;
};

export const OrderElement: React.FC<OrderElementProps> = ({ order }) => {
  const history = useHistory();
  const [t] = useLanguage();
  const [allExpiredPurchase, setAllExpiredPurchase] = useState(true);

  useEffect(() => {
    let nonExpiredPurchase = (order?.purchaseItems || []).filter((p) => {
      const now = dayjs();
      const created = dayjs(p.createdAt);
      return !(now.diff(created, 'hours') > 6 && p.status === 'NEW');
    });
    setAllExpiredPurchase(isEmpty(nonExpiredPurchase));
  }, [order?.purchaseItems]);

  const goToTrakingWithCorrectOrder = useCallback(() => {
    return history.push(`${Routes.Home}?id=${order.opaqueId}`);
  }, [history, order.opaqueId]);

  const goToDetailsCorrectOrder = useCallback(() => {
    history.push(
      `${Routes.ChooseTransaction.replace(':orderId', `${order.id}`)}`
    );
  }, [history, order.id]);

  const orderDescription = getOrderDescription(
    order.status,
    order.suspended,
    t
  );
  const serviceDate = useServiceDate(order);

  return (
    <div className="order-element--row-container">
      <div className="order-element--shipper-row">
        <p className="order-element--shipper">
          {order.shipper.name || order.shipper.name}
        </p>
        <p className="order-element--date">
          {serviceDate?.format('DD MMM YYYY')}
        </p>
      </div>
      <p className="order-element--tracking-number">{order.shipperOrderCode}</p>
      {orderDescription && (
        <p className="order-element--status">{orderDescription}</p>
      )}
      <div className="order-element--badges-container">
        <BadgeButton
          onClick={goToTrakingWithCorrectOrder}
          label={t('orders.tracking')}
          isPrimary
        />
        {order.purchaseItems &&
          order.purchaseItems.length > 0 &&
          !allExpiredPurchase && (
            <BadgeButton
              onClick={goToDetailsCorrectOrder}
              label={t('orders.details')}
            />
          )}
      </div>
    </div>
  );
};
